// src/pages/UmatDataUpdate.js
import React, { useState, useEffect } from "react";
import TwoColumnLayout from "../layouts/TwoColumnLayout"; // pastikan path sesuai
import TopNavTabs from "../components/TopNavTabs"; // pastikan path sesuai
import { useHistory } from "react-router-dom"; // react-router-dom v5
import { getUser, getJwt } from "../utils/auth"; // util auth yang sudah ada
import { apiFetch } from "../utils/wkCommon"; // wrapper fetch yang menambahkan Authorization
import "../layouts/TwoColumnLayout.css"; // untuk konsistensi look & feel
import UmatUpdateIndividual from "../components/UmatUpdateIndividual";
import UmatUpdateMulti from "../components/UmatUpdateMulti";
import UmatMappingQiuDao from "../components/UmatMappingQiuDao"
import UmatUpdateApproval from "../components/UmatUpdateApproval"
import { useLocation } from "react-router-dom";

const API_URL = process.env.REACT_APP_BACKEND_URL || ""; // gunakan env, jangan hardcode

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function UmatDataUpdate() {
  const history = useHistory();

  function handleBack() {
    history.goBack();
  }

  return (
    <TwoColumnLayout
      leftNode={null}
      rightNode={<MainPanel API_URL={API_URL} />}
      variant="oneColumn"
      title="Update Data Umat"
      showBack={true}
      onBack={handleBack}
      headerActions={<div></div>}
    />
  );
}

/* ---------- small presentational components used inside layout ---------- */

function HeaderPanel({ title, subtitle, loading }) {
  // leftNode content; keep simple card-like panel similar to TwoColumnLayout panels
  return (
    <div style={{ fontSize: "0.95rem" }}>
      <div style={{ marginBottom: "0.5rem", fontWeight: 700, fontSize: "1rem" }}>{title}</div>
      <div style={{ color: "#333", marginBottom: "0.75rem", fontSize: "0.9rem" }}>{subtitle}</div>
      <div style={{ fontSize: "0.85rem", color: "#666" }}>
        {loading ? "Loading summary..." : "Use tabs on the top to switch sections."}
      </div>
    </div>
  );
}

function MainPanel({ API_URL }) {

  const query = useQuery();

  const [activeTab, setActiveTab] = useState(
    query.get("tab") || "individual"
  );

  const umatId = query.get("umat") || null;

  const [summary, setSummary] = useState({ pending: 0, conflicts: 0 });
  const [loading, setLoading] = useState(false);

  const tabs = [
    { key: "individual", label: "Individual" },
    { key: "multi", label: "Multi" },
    { key: "mapping", label: "Mapping to QiuDao" },
    { key: "approval", label: "Approval", badge: null }, //summary.pending > 0 ? String(summary.pending) : null },
  ];

  /*
  useEffect(() => {
    // contoh: ambil ringkasan perubahan yang perlu di-approve
    let mounted = true;
    async function loadSummary() {
      setLoading(true);
      try {
        // contoh endpoint; ganti sesuai impl Strapi kamu
        const resp = await apiFetch(`/api/umats-updates/summary`);
        if (!mounted) return;
        setSummary({
          pending: resp?.data?.pending ?? 0,
          conflicts: resp?.data?.conflicts ?? 0,
        });
      } catch (err) {
        // fallback: kosongkan summary
        if (!mounted) return;
        setSummary({ pending: 0, conflicts: 0 });
        // console.warn(err);
      } finally {
        if (mounted) setLoading(false);
      }
    }

    loadSummary();
    return () => { mounted = false; };
  }, []);
*/
  function handleTabChange(key) {
    setActiveTab(key);
    // optional: reset scroll or other UI behavior
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
  
  return (
    <div>
      <div style={{ marginBottom: "0.75rem", fontSize: "0.9rem" }}>
        <TopNavTabs
          items={tabs}
          activeKey={activeTab}
          onTabClick={(k) => handleTabChange(k)}
          className="umat-update-tabs"
          tabStyle={{ fontSize: "1rem" }}
        />
      </div>

      <div style={{ background: "#fff", borderRadius: "8px", border: "1px solid #e6eef8", padding: "1rem" }}>
        {activeTab === "individual" && 
            <UmatUpdateIndividual umatId={umatId} onSaved={(resp)=> {
            // contoh: refresh summary / approval list setelah submit
            // loadSummary?.();
        }} />}
        {activeTab === "multi" &&
            <UmatUpdateMulti onSaved={(resp)=> {
            // contoh: refresh summary / approval list setelah submit
            // loadSummary?.();
        }} />}
        {activeTab === "mapping" && 
            <UmatMappingQiuDao umatId={umatId} onSaved={(resp)=> {
            // contoh: refresh summary / approval list setelah submit
            // loadSummary?.();
        }} />}
        {activeTab === "approval" && 
            <UmatUpdateApproval onSaved={(resp)=> {
            // contoh: refresh summary / approval list setelah submit
            // loadSummary?.();
        }} />}
      </div>
    </div>
  );
}

/* ---------- Placeholder tabs (implement details per requirements) ---------- */

function IndividualTab({ API_URL }) {
  const [email, setEmail] = useState("");
  const [umat, setUmat] = useState(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  async function handleLookup(e) {
    e && e.preventDefault();
    setError(null);
    setUmat(null);
    if (!email) return setError("Masukkan email untuk mencari umat.");
    try {
      const q = encodeURIComponent(email);
      // example: consistent with wkCommon getUmatByEmail behavior
      const url = `${API_URL}/api/umats?filters%5BLoginEmail%5D%5B$eq%5D=${q}&populate=*`;
      const resp = await fetch(url); // intentionally using native fetch like getUmatByEmail
      if (!resp.ok) {
        const txt = await resp.text().catch(()=>"");
        throw new Error(`HTTP ${resp.status} - ${txt}`);
      }
      const json = await resp.json();
      const arr = json?.data || [];
      if (!arr || arr.length === 0) return setError("Tidak ditemukan umat untuk email ini.");
      setUmat(arr[0]);
    } catch (err) {
      setError(err.message || String(err));
    }
  }

  async function handleSaveChanges(changes) {
    // contoh submit perubahan: buat patch/update ke Strapi via apiFetch (menggunakan Authorization jika ada)
    setSaving(true);
    try {
      // per Strapi v5: update by documentId: /api/umats/{documentId}
      const docId = umat?.id ?? (umat?.documentId ?? null);
      if (!docId) throw new Error("No umat selected.");
      // gunakan apiFetch wrapper (yang menambahkan Authorization header)
      await apiFetch(`/api/umats/${docId}`, { method: "PUT", body: { data: changes } });
      alert("Perubahan tersimpan.");
    } catch (err) {
      alert("Gagal menyimpan: " + (err.message || String(err)));
    } finally {
      setSaving(false);
    }
  }

  return (
    <div>
      <form onSubmit={handleLookup} style={{ display: "flex", gap: "0.5rem", marginBottom: "1rem" }}>
        <input
          type="email"
          placeholder="Cari berdasarkan LoginEmail"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{ flex: 1, padding: "0.6rem", fontSize: "0.95rem", borderRadius: "6px", border: "1px solid #dfe7f6" }}
        />
        <button type="submit" className="btn-icon" style={{ minWidth: "6rem", fontSize: "0.95rem" }}>Lookup</button>
      </form>

      {error && <div style={{ color: "crimson", marginBottom: "0.6rem" }}>{error}</div>}

      {umat ? (
        <div>
          <h4 style={{ marginTop: 0, fontSize: "1rem" }}>Hasil: {umat?.attributes?.NamaLengkap ?? umat?.NamaLengkap ?? "—"}</h4>
          {/* Contoh field yang bisa diedit — ganti/expand sesuai field actual */}
          <EditableField label="Nama Lengkap" value={getAttr(umat, "NamaLengkap")} onSave={(v) => handleSaveChanges({ NamaLengkap: v })} saving={saving} />
          <EditableField label="No Telp" value={getAttr(umat, "mobilePhone")} onSave={(v) => handleSaveChanges({ mobilePhone: v })} saving={saving} />
        </div>
      ) : (
        <div style={{ color: "#666" }}>Masukkan email dan tekan Lookup untuk mulai.</div>
      )}
    </div>
  );
}

function MultiTab() {
  return (
    <div>
      <p style={{ marginTop: 0 }}>Multi — upload / batch changes. Implementasikan CSV / Excel upload & parsing di sini.</p>
      <p style={{ color: "#666" }}>Contoh langkah: upload file → preview → map fields → submit bulk changes to Strapi.</p>
    </div>
  );
}

function MappingTab() {
  return (
    <div>
      <p style={{ marginTop: 0 }}>Mapping to QiuDao — buat pemetaan umat ke QiuDao (lookup, auto-suggest, mapping preview).</p>
      <p style={{ color: "#666" }}>Biasanya melibatkan pencarian bandao/qiu dao list dan menyimpan relasi via API.</p>
    </div>
  );
}

function ApprovalTab() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let mounted = true;
    async function loadPending() {
      setLoading(true);
      try {
        // contoh endpoint; adapt sesuai implementasi backend
        const resp = await apiFetch(`/api/umats-updates?filters%5Bstatus%5D%5B$eq%5D=pending&populate=*`);
        if (!mounted) return;
        setItems(resp?.data || []);
      } catch (err) {
        if (!mounted) return;
        setItems([]);
      } finally {
        if (mounted) setLoading(false);
      }
    }
    loadPending();
    return () => { mounted = false; };
  }, []);

  async function handleApprove(itemId) {
    try {
      await apiFetch(`/api/umats-updates/${itemId}/approve`, { method: "POST", body: {} });
      setItems((s) => s.filter(it => it.id !== itemId));
      alert("Approved");
    } catch (err) {
      alert("Failed to approve: " + (err.message || String(err)));
    }
  }

  return (
    <div>
      <h4 style={{ marginTop: 0 }}>Approval</h4>
      {loading ? <div>Loading...</div> : (
        items.length === 0 ? <div style={{ color: "#666" }}>Tidak ada item pending.</div> :
        <ul>
          {items.map(it => (
            <li key={it.id} style={{ marginBottom: "0.6rem", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <div style={{ fontWeight: 600 }}>{it?.attributes?.title ?? `Update #${it.id}`}</div>
                <div style={{ fontSize: "0.85rem", color: "#666" }}>{it?.attributes?.summary ?? ""}</div>
              </div>
              <div style={{ display: "flex", gap: "0.5rem" }}>
                <button className="btn-icon" onClick={() => handleApprove(it.id)}>Approve</button>
                <button className="btn-icon" onClick={() => alert("Open details (implement)")}>Details</button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

/* ---------- small UI helpers ---------- */

function EditableField({ label, value, onSave, saving }) {
  const [editMode, setEditMode] = useState(false);
  const [val, setVal] = useState(value ?? "");

  useEffect(() => setVal(value ?? ""), [value]);

  return (
    <div style={{ marginBottom: "0.75rem" }}>
      <label style={{ display: "block", fontSize: "0.85rem", marginBottom: "0.25rem" }}>{label}</label>
      {editMode ? (
        <div style={{ display: "flex", gap: "0.5rem" }}>
          <input value={val} onChange={(e) => setVal(e.target.value)} style={{ flex: 1, padding: "0.5rem", fontSize: "0.95rem" }} />
          <button className="btn-icon" onClick={() => { onSave(val); setEditMode(false); }} disabled={saving || !val}>Save</button>
          <button className="btn-icon" onClick={() => { setVal(value ?? ""); setEditMode(false); }}>Cancel</button>
        </div>
      ) : (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ color: "#111" }}>{value ?? "—"}</div>
          <button className="btn-icon" onClick={() => setEditMode(true)}>Edit</button>
        </div>
      )}
    </div>
  );
}

function getAttr(item, key) {
  // helper to handle Strapi v4/v5 differences
  if (!item) return null;
  const attrs = item.attributes ?? item;
  return attrs?.[key] ?? null;
}
